/**
 * Email Event Status Badge Component
 *
 * Displays a colored badge indicating if an email event is enabled or disabled.
 */

import { Badge, BadgeProps } from "@mantine/core";

/**
 * Props for EmailEventStatusBadge
 */
export interface EmailEventStatusBadgeProperties {
  /** Whether the event is enabled */
  enabled: boolean;
  /** Optional badge size */
  size?: BadgeProps["size"];
  /** Optional badge radius */
  radius?: BadgeProps["radius"];
}

/**
 * EmailEventStatusBadge Component
 * @param root0
 * @param root0.enabled
 * @param root0.size
 * @param root0.radius
 * @example
 * <EmailEventStatusBadge enabled={true} />
 * <EmailEventStatusBadge enabled={false} size="lg" />
 */
export function EmailEventStatusBadge({ enabled, size = "sm", radius = "sm" }: EmailEventStatusBadgeProperties) {
  return (
    <Badge color={enabled ? "green" : "gray"} variant="light" size={size} radius={radius}>
      {enabled ? "Ativo" : "Inativo"}
    </Badge>
  );
}

EmailEventStatusBadge.displayName = "EmailEventStatusBadge";
